export enum TabsType {
    PHONE = "phone",
    EMAIL = "email",
    BILL = "bill"
}